import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import axios from 'axios'
//import auth from '@/auth'
//import './../node_modules/bulma/css/bulma.css';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import {ClientTable} from 'vue-tables-2'
Vue.use(ClientTable, {}, false, 'bulma');

//font awesome icons import 
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faCalendar, faKey, faArrowUp, faAngleRight, faAngleLeft, faAngleDown, faSort, faSortUp, faSortDown, faCog, faEye, faEyeSlash, faTh, faThLarge, faAlignJustify, faWindowMaximize, faUpload, faDownload} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUser, faCalendar,faArrowUp, faKey, faAngleRight, faAngleLeft, faAngleDown, faSort, faSortUp, faSortDown, faCog, faEye, faEyeSlash, faTh, faThLarge, faAlignJustify, faWindowMaximize, faUpload, faDownload)

/**
 * Setting this config so that Vue-tables-2 will be able to replace sort icons with chevrons
 * https://fontawesome.com/how-to-use/with-the-api/setup/configuration
 */
import { config } from '@fortawesome/fontawesome-svg-core'
config.autoReplaceSvg = "nest";

/**
 * Allows DOM to change <i> tags to SVG for more features like layering
 * https://fontawesome.com/how-to-use/on-the-web/styling/layering
 */
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch();
Vue.component('vue-fontawesome', FontAwesomeIcon);
Vue.component('font-awesome-icon', FontAwesomeIcon)
//end of font awesome icons import 


import Buefy from 'buefy'

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
})


Vue.prototype.$axios = axios //You can access axios using this.$axios

Vue.config.productionTip = false

//csv downloader
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')